<template>
  <div class="myevents container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Schedule</h4>
              </div>
            </div>
          </div>
          <b-card no-body id="myscheduleMIDCard" class="p-3">
            <FullCalendar
              :options="calendarOptions"
              :eventsources="calendarOptions.eventSources"
              :config="config"
            />
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import $ from "jquery";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import moment from "moment";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        // displayEventTime: true,
        headerToolbar: {
          // left: 'title',
          // left:'prev title next',
          // center: 'agendaDay,agendaWeek,month,agendaYear',
          // right:'today',
          left: "prev next title",
          center: "today",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
          // center: 'agendaDay,agendaWeek,month',
          // right: 'prev,next today'
        },
        eventLimit: true,

        dayMaxEvents: 2,

        // Dynamic Event Source
        eventSources: [
          {
            events(start, callback) {
              console.log(start.start, start.end);
              console.log(axios.defaults.baseURL);
              let formData = new FormData();
              formData.append("from", start.start);
              formData.append("to", start.end);
              axios
                .get("event/calendar?from="+moment(start.start).format("yyyy-MM-DD")+"&to="+moment(start.end).format("yyyy-MM-DD"),  {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    client: "MID",
                    Authorization:
                      "Bearer " +
                      JSON.parse(window.localStorage.getItem("user"))
                        .access_token,
                  },
                })
                .then((response) => {
                  console.log(response);
                  callback(response.data);
                })
                .catch((error) => {
                  console.log(error.response.data.error);
                  console.log(error.request);
                  console.log(error.message);
                  // this.$fire({
                  //   // title: "Title",
                  //   text: error.response.data.error,
                  //   type: "error",
                  //   // timer: 5000,
                  // }).then((r) => {
                  //   // console.log(r.value);
                  // });
                  // this.loginErrorMessage = error.response.data.error;
                  // this.showLoginErrorMessage = true;
                });
            },
          },
        ],
        // events: [
        //   {
        //     id: 1111,
        //     title: "Live Class",
        //     start: "2022-05-6",
        //     className: "large_host_centered",
        //   },
        //   {
        //     id: 12222,
        //     title: "Live Class",
        //     start: "2022-05-13",
        //     className: "large_host_centered",
        //   },
        //   {
        //     title: "Dating Course",
        //     start: "2022-05-06",
        //     className: "large_interactive",
        //   },
        //   {
        //     title: "Blind Dating",
        //     start: "2022-05-06",
        //     className: "small_group",
        //   },
        //   {
        //     title: "Blind Dating",
        //     start: "2022-05-06",
        //     className: "large_interactive",
        //   },
        //   {
        //     title: "Dating Course",
        //     start: "2022-05-12",
        //     className: "large_interactive",
        //   },
        //   {
        //     title: "Live Class",
        //     start: "2022-05-16T22:00:00",
        //     end:"2022-05-16T20:00:00",
        //     className: "small_group",
        //   },
        // ],
        eventClick: (event) => {
          console.log("event");
          console.log(event);
        },
      },
      config: {
        eventClick: (event) => {
          console.log(event);
        },
      },
    };
  },

  methods: {},
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/Calendar.vue